import React from 'react';
import PropTypes from 'prop-types';
import Button from 'src/ui/library/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import styled from 'src/ui/library/styled';
//import withMobileDialog from '@mui/material/withMobileDialog';
import CloseIcon from '@mui/icons-material/Close';

const styles = (theme, props) => ({
  root: {},
  rootPaper: {
    padding: '32px',
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '0px',
    margin: '0px',
    fontSize: '24px',
    color: theme.colors.eyConfidentGrey,
    flexGrow: 1,
  },
  closeIcon: {
    cursor: 'pointer',
  },
  divider: {
    marginTop: '20px',
    height: '1px',
    width: '100%',
    border: '0.5px solid #CCC',
    opacity: '0.7',
  },
  contentRoot: {
    padding: '20px 0px 0px 0px',
  },
  contentText: {
    color: theme.colors.eyConfidentGrey,
    fontSize: '14px',
  },
  actionsRoot: {
    flexDirection: props.dialogClassName==="priceLockInfoDialog"?'row-reverse':'row',
    margin: '24px 0px 0px 0px',
    justifyContent: 'flex-start',
    width: '100%',
    maxWidth: '450px',
  },
  buttonAction: {
    // margin: '0px 16px 0px 0px',
  },
});

class ConfirmDialog extends React.Component {
  static propTypes = {
    /** Open/close dialog */
    open: PropTypes.bool.isRequired,
    /** Set max width for cancel & confirm btns */
    noMaxWidthBtns: PropTypes.bool,
    maxWidth: PropTypes.string,
    /** Text for the Dialog title */
    title: PropTypes.string,
    /** Optional icon rendered before the title text */
    titleIcon: PropTypes.node,
    /** Text for the cancel button */
    cancelText: PropTypes.string,
    /** Text for the confirm button */
    confirmText: PropTypes.string.isRequired,
    /** Callback fired when cancel button click */
    onCancel: PropTypes.func,
    /** Callback fired when confirm button click */
    onConfirm: PropTypes.func,
    onClose: PropTypes.func,
    /** Classes injected from MUI Styles */
    classes: PropTypes.object,
    /** Provided children */
    children: PropTypes.node,
    closeIcon: PropTypes.bool,
    dialogClassName: PropTypes.string,
    disabledbtn: PropTypes.bool,
    noCancel: PropTypes.bool,
  };

  static defaultProps = {
    maxWidth: 'md',
    noMaxWidthBtns: true,
  };

  render() {
    const {
      cancelText,
      maxWidth,
      confirmText,
      onCancel,
      onConfirm,
      title,
      titleIcon,
      classes,
      children,
      open,
      noCancel,
      noMaxWidthBtns,
      dialogClassName,
      onClose,
      closeIcon,
      disabledbtn
    } = this.props;

    const hasTitleContent = Boolean(title || titleIcon || closeIcon);

    return (
      <Dialog maxWidth={maxWidth} classes={{ root: classes.root, paper: classes.rootPaper }} className={dialogClassName} open={open}>

        {hasTitleContent && (
          <div className={classes.titleContainer}>
            <h2 className={classes.title} id="confirm-title">
              {titleIcon}
              {title}
            </h2>
            {closeIcon && <CloseIcon className={classes.closeIcon} onClick={onClose || null} />}
          </div>
        )}
        <DialogContent classes={{ root: classes.contentRoot }}>
          <DialogContentText component="div" classes={{ root: classes.contentText }}>{children}</DialogContentText>
        </DialogContent>
        <div className={classes.divider} />
        <DialogActions classes={{ root: classes.actionsRoot, spacing: classes.buttonAction }}>
          {!noCancel && (
            <Button onClick={onCancel || null} noMaxWidth={noMaxWidthBtns} styleType={'secondary'}>
              {cancelText}
            </Button>
          )}
          <Button disabled={disabledbtn} onClick={onConfirm || null} noMaxWidth={noMaxWidthBtns}>
            {confirmText}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export { ConfirmDialog };
export default styled(ConfirmDialog)(styles);
